<snelstart-ui-button type="secondary"
                     class="custom-input-150"
                     icon="magnifying-glass"
                     (click)="this.showDialog()">Specificatie
</snelstart-ui-button>

<snelstart-ui-dialog-definition id="lg" title="Specificatie eindvermogen" size="lg"
                                [(visible)]="dialogVisible">
    <snelstart-ui-dialog-body>

        <form [formGroup]="eigenVermogenFg">
            <div>
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog ">
                        <p>Eigen vermogen</p>
                    </div>
                    <div>
                        <snelstart-ui-number-form-control formControlName="eigenVermogenEindstand"
                                                          id="eigenVermogenEindstand"
                                                          class="custom-input-150"
                                                          [decimals]="0"
                                                          align="right"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </form>

        <form [formGroup]="rapportFormGroup">
            <ng-container formGroupName="specificatieWuo">
                <ng-container formGroupName="opbouw">

                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Kostenegalisatiereserve</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="eindstandKER"
                                                                  id="eindstandKER"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Herinvesteringsreserve</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="eindstandHIR"
                                                                  id="eindstandHIR"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Fiscale oudedagsreserve</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="eindstandFOR"
                                                                  id="eindstandFOR"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Totaal eindvermogen</p>
                            </div>
                            <div class="flex-item-ruimte-dialog"></div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="totaleEindvermogen"
                                                                  id="totaleEindvermogen"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </form>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button id="cancel" class="me-2" type="secondary" btn-x>Annuleren</snelstart-ui-button>
        <snelstart-ui-button id="save" type="primary" icon="check">Akkoord</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
